import { Component } from '@angular/core';

@Component({
  selector: 'app-brand-assets',
  templateUrl: './brand-assets.component.html',
})
export class BrandAssetsComponent {
}
